import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.order-planning-configuration')
  .factory('$orderPlanningMonitor', OrderPlanningMonitorObjectFactory);

/* @ngInject */
function OrderPlanningMonitorObjectFactory($bringozFactory: $bringozFactory,
                                           OrdersPlanningMonitorAPI: BringozApi) {

  function $orderPlanningMonitor(id: string) {
    return $bringozFactory(id, OrdersPlanningMonitorAPI);
  }

  return $orderPlanningMonitor;
}
